import React from 'react';
import { I } from './Icons';

type IconName = keyof typeof I;

interface EmptyStateProps {
  icon?: IconName;
  title: string;
  sub?:  string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon = 'Folder', title, sub }) => {
  const IconC = I[icon];
  return (
    <div className="text-center py-12 px-4">
      <div className="text-ink-300 mx-auto mb-3" style={{ width: 48, height: 48 }}>
        <IconC size={48} stroke={1.5} />
      </div>
      <p className="text-ink-500 text-sm font-semibold m-0">{title}</p>
      {sub && <span className="text-ink-400 text-xs">{sub}</span>}
    </div>
  );
};
